import { FormControl, Typography } from "@mui/material";
import { FoodsSelectServerPagination } from "@foodpilot/foods";
import { useGetAllSsq } from "src/api/sure-api/ssq/useGetAllSsq";
import { useGetOneSsq } from "src/api/sure-api/ssq/useGetOneSsq";
import { useDelayedSearch } from "src/utils/useDelayedSearch";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type SsqFieldProps = {
    ssq_id: number | null | undefined;
    setSsqId: (ssqId: number | null) => void;
};

export const SsqField = (props: SsqFieldProps) => {
    const { ssq_id, setSsqId } = props;
    const { t } = useTranslation();
    const { ssqs = [] } = useGetAllSsq();
    const { ssq: singleSsq } = useGetOneSsq(ssq_id ?? undefined);
    const allSsqs = useMemo(() => {
        if (singleSsq && !ssqs.some((s) => s.id === singleSsq.id)) {
            return [...ssqs, singleSsq];
        }
        return ssqs;
    }, [ssqs, singleSsq]);
    const { search, setSearch, delayedSearch } = useDelayedSearch();
    const isSearchFound = (value: string) =>
        delayedSearch === "" || value.toLowerCase().includes(delayedSearch.toLowerCase());
    const selectedSsq = allSsqs.find((ssq) => ssq.id === ssq_id) ?? null;

    return (
        <FormControl size="small">
            <Typography variant="h5" sx={{ paddingBottom: "0.5rem" }}>
                {`${t("SSQ")}:`}
            </Typography>
            <FoodsSelectServerPagination
                onChange={(data) => setSsqId(data ? data.id : null)}
                options={allSsqs}
                selectedOption={selectedSsq}
                getId={(item) => item.id}
                getName={(item) => item.title}
                textOptions={{
                    placeholder: t("component.select.placeholder"),
                    searchPlaceholder: t("component.select.searchPlaceholder"),
                    emptyOptionsText: t("component.select.noOptions"),
                    defaultValueText: t("component.select.defaultValue"),
                    noResult: t("component.select.noResultFound"),
                }}
                search={search}
                setSearch={setSearch}
                isSearchFound={isSearchFound}
                BoxProps={{ width: "75%" }}
                BoxOptionsProps={{ width: "450px" }}
            />
        </FormControl>
    );
};
